export const CONTACT_FORM_LINK = 'Contact Form';
export const DOWNLOAD_LINK = 'Download Link';
export const EMAIL = 'Email';
export const EMAIL_LINK = 'Contact Via Email';
export const FAX = 'Fax';
export const MAIL = 'Mail';
export const PHONE = 'Phone';
export const WEB_LINK = 'External Link';
export const ZIP_CODE = 'Zip Codes';
